import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function RecuperarSenha() {
  const { resetPassword } = useAuth()
  const [passo, setPasso] = useState(1)
  const [email, setEmail] = useState('')
  const [erro, setErro] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleEnviarCodigo(e) {
    e.preventDefault()
    setErro('')
    setLoading(true)
    const { error } = await resetPassword(email)
    setLoading(false)
    if (error) {
      if (error.status === 429 || error.message?.includes('rate limit') || error.message?.includes('too many')) {
        setErro('Muitas tentativas seguidas. Aguarde alguns minutos e tente novamente.')
      } else {
        setErro('E-mail não encontrado.')
      }
    }
    else setPasso(2)
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}><div style={styles.dot}></div><span>NFL Survival 2026</span></div>
        <h1 style={styles.title}>Recuperar senha</h1>
        <p style={styles.sub}>Siga os 3 passos abaixo</p>

        <div style={styles.steps}>
          {[1, 2, 3].map(n => (
            <div key={n} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <div style={{
                width: 22, height: 22, borderRadius: '50%', display: 'flex',
                alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 500,
                background: n < passo ? '#EAF3DE' : n === passo ? '#D85A30' : '#eee',
                color: n < passo ? '#3B6D11' : n === passo ? 'white' : '#999',
              }}>{n < passo ? '✓' : n}</div>
              {n < 3 && <div style={{ flex: 1, height: 1, background: '#eee', width: 40 }}></div>}
            </div>
          ))}
        </div>

        {passo === 1 && (
          <form onSubmit={handleEnviarCodigo}>
            <p style={styles.stepTitle}>Passo 1 — informe seu e-mail</p>
            <p style={styles.stepSub}>Enviaremos um link de redefinição</p>
            <div style={styles.field}>
              <label style={styles.label}>E-mail cadastrado</label>
              <input style={styles.input} type="email" value={email}
                onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required />
            </div>
            {erro && <p style={styles.erro}>{erro}</p>}
            <button style={styles.btn} type="submit" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar link'}
            </button>
          </form>
        )}

        {passo === 2 && (
          <div>
            <p style={styles.stepTitle}>Passo 2 — verifique seu e-mail</p>
            <p style={styles.stepSub}>Enviamos um link para <strong>{email}</strong>. Clique nele para redefinir sua senha. Verifique também a caixa de spam.</p>
            <div style={{ ...styles.successBox, marginTop: '1rem' }}>
              Link enviado com sucesso!
            </div>
          </div>
        )}

        <p style={styles.link}><Link to="/login">← Voltar ao login</Link></p>
      </div>
    </div>
  )
}

const styles = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', background: '#f5f5f5' },
  card: { background: 'white', borderRadius: 12, padding: '2rem', width: '100%', maxWidth: 380, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  logo: { display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center', marginBottom: '1.5rem', fontSize: 16, fontWeight: 500 },
  dot: { width: 9, height: 9, background: '#D85A30', borderRadius: '50%' },
  title: { fontSize: 16, fontWeight: 500, textAlign: 'center', marginBottom: 4 },
  sub: { fontSize: 13, color: '#666', textAlign: 'center', marginBottom: '1.2rem' },
  steps: { display: 'flex', alignItems: 'center', gap: 4, marginBottom: '1.2rem' },
  stepTitle: { fontSize: 13, fontWeight: 500, marginBottom: 3 },
  stepSub: { fontSize: 12, color: '#666', marginBottom: '0.8rem' },
  field: { marginBottom: '1rem' },
  label: { display: 'block', fontSize: 12, color: '#666', marginBottom: 4 },
  input: { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  btn: { width: '100%', padding: 12, background: '#D85A30', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer' },
  erro: { color: '#A32D2D', fontSize: 13, background: '#FCEBEB', padding: '8px 12px', borderRadius: 8, marginBottom: 8 },
  successBox: { background: '#EAF3DE', color: '#3B6D11', fontSize: 13, padding: '10px 14px', borderRadius: 8 },
  link: { fontSize: 12, color: '#666', textAlign: 'center', marginTop: 12 },
}
